module.exports = __webpack_public_path__ + "img/profile-pic.b6b747f5.jpg";